module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qhead13-9d7c3cfa48737ee265cb657987a1a939.jpg";